import { Box, Typography } from '@mui/material';

export const MaintenanceBanner = (props: {
  backgroundColor: string;
  textColor: string;
  text: string | undefined;
}) => {
  const { backgroundColor, textColor, text } = props;
  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: backgroundColor,
        textAlign: 'center',
        color: textColor,
      }}
    >
      <Typography variant='body1' sx={{ fontWeight: 'bold' }}>
        {text}
      </Typography>
    </Box>
  );
};
